import {PREFIX} from "./ConstantService";
import {UrlService} from "./UrlService";
import axios from "axios";
import {GlobalService} from "./GlobalService";

export const ExcelService = {
  async csv(entity, filters = null) {
    let response = null;
    let queryString=UrlService.setQueryString(filters)
    try {
      switch (entity) {
        case 'ACCIDENT INCIDENT':
          response = await axios.get(PREFIX + 'csv/accident-incidents'+queryString,{responseType: 'blob'})
          break;
        case 'ACCIDENT_INCIDENT_EVENT':
          response = await axios.get(PREFIX + 'csv/accident-incidents-per-event'+queryString,{responseType: 'blob'})
          break;
        case 'ACCIDENT_INCIDENT_BY_EVENT':
          response = await axios.get(PREFIX + 'csv/accident-incidents-by-event'+queryString,{responseType: 'blob'})
          break;
        case 'RIGHTSHIP':
          response = await axios.get(PREFIX + 'csv/rightship'+queryString,{responseType: 'blob'})
          break;
        case 'RIGHTSHIP_EVENT':
          response = await axios.get(PREFIX + 'csv/rightship-per-finding'+queryString,{responseType: 'blob'})
          break;
        case 'RIGHTSHIP_EVENT_FINDINGS_BY_PORTS':
          response = await axios.get(PREFIX + 'csv/rightship-per-finding-by-ports'+queryString,{responseType: 'blob'})
          break;
        case 'RIGHTSHIP_INSPECTOR_EVENT':
          response = await axios.get(PREFIX + 'csv/rightship-inspector-finding'+queryString,{responseType: 'blob'})
          break;
        case 'RIGHTSHIP_FINDINGS_BY_PORTS_EVENT':
          response = await axios.get(PREFIX + 'csv/rightship-findings-by-ports'+queryString,{responseType: 'blob'})
          break;
        default:
          response = await axios.get(PREFIX + 'csv/accident-incidents',{responseType: 'blob'})
          break;
      }
      const filename= entity + ' LIST - ' + Date.now()
      this.downloadExcel(entity, response, filename);
    }
    catch (errors) {
      GlobalService.handleError(errors, 'GENERATE CSV SERVICE')
      return false
    }
  },
  async postCsv(entity, params = null) {
    let response = null;
    try {
      switch (entity) {
        case 'SAFETY_AND_HEALTH':
          response = await axios.post(PREFIX + 'csv/accident-incident-safety-and-health', params,{responseType: 'blob'})
          break;
      }
      this.downloadExcel(entity, response, params.file_name, 'application/vnd.ms-excel');
    }
    catch (errors) {
      GlobalService.handleError(errors, 'GENERATE CSV SERVICE')
      return false
    }
  },
  downloadExcel(entity, response, fileName, fileType = 'text/csv') {
    if(response?.data) {
      const fileUrl = window.URL.createObjectURL(new Blob([response.data],{type:fileType}));
      const link = document.createElement('a');
      link.setAttribute('href', fileUrl);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }
  },
}
